import { ModuleWithProviders, NgModule } from '@angular/core';

import { PRELOAD } from './constants';
import { AtxPreloadService } from './services';

@NgModule({
    providers: [
        AtxPreloadService,
    ],
})

export class AtxPreloadModule {
    static forRoot(preload): ModuleWithProviders {
        return {
            ngModule: AtxPreloadModule,
            providers: [
                {
                    provide: PRELOAD,
                    multi: true,
                    useValue: preload,
                },
            ],
        };
    }
}
